class ToggleElement {
  constructor(element) {
    this.element = element
    this.target = element.getAttribute('data-target')
    this.classes = element.getAttribute('data-classes')
    this.siblingsClass = element.getAttribute('data-siblings')
    this.delayedClasses = element.getAttribute('data-delayed-classes')
 

    const targetDomEl = document.querySelector(this.target) ?? element
    
    this.scrollBehabviour = element.getAttribute('data-scroll')
    
    this.element.addEventListener('click', (event) => {
      const elementAriaExpanded = (this.element.getAttribute('aria-expanded') === 'true')
      
      event.preventDefault()
      
      const siblings = [...document.querySelectorAll(this.siblingsClass)]

      if ( siblings.length ) {
        siblings.forEach( item => {
          if (item == targetDomEl || ! elementAriaExpanded) {
            item.setAttribute('aria-expanded', 'true')
          }else{
            item.setAttribute('aria-expanded', 'false')
          }
        })
      } 


      //for animaiton and visible in css
      if ( this.delayedClasses) {
        if (elementAriaExpanded) {
          setTimeout(() => {
            targetDomEl.classList.remove(this.delayedClasses)
           }, 300);
        }else{
          targetDomEl.classList.add(this.delayedClasses)
        }
      }
      if (this.classes) {
        targetDomEl.classList.toggle(this.classes)
      }
   
     

    }, false)
    
  }
}

export default ToggleElement
